import { useRef, useState } from "react";
import { bankStats, useImportQuestions, useQuestionBanks } from "@/app/questionQueries";
import { plural } from "@/lib/plural";
import { Button } from "@/ui/Button";

/** Импорт вопросов банка из CSV (SP4 §4): question, answer, tags через ;, asked_count, source.
 *  Повторный импорт обновляет вопросы с тем же текстом, дублей не плодит. */
export function BankImport({ bank }: { bank: string }) {
  const input = useRef<HTMLInputElement>(null);
  const banks = useQuestionBanks();
  const imp = useImportQuestions(bank);
  const [report, setReport] = useState<{ imported: number; skipped: string[] } | null>(null);
  const name = bank.trim();
  const stats = bankStats(banks.data, name, plural);
  const onFile = async (f: File | undefined) => {
    if (!f) return;
    setReport(null);
    try {
      setReport(await imp.mutateAsync(await f.text()));
    } catch {
      // причина — в imp.error
    } finally {
      if (input.current) input.current.value = "";
    }
  };
  return (
    <div className="flex flex-col items-end gap-1.5" data-testid="bank-import">
      <input ref={input} type="file" accept=".csv,text/csv" aria-label="файл вопросов csv" className="hidden" onChange={(e) => void onFile(e.target.files?.[0])} />
      <Button size="sm" disabled={!name || imp.isPending} reason={!name ? "сначала назови банк" : imp.isPending ? "импортируем…" : undefined} onClick={() => input.current?.click()}>
        импорт вопросов csv
      </Button>
      <span className="font-mono text-[11px] text-mut">{stats || "в банке пока нет вопросов"}</span>
      {report && (
        <span className="font-mono text-[11px] text-ok" role="status">
          импортировано {report.imported} {plural(report.imported, "вопрос", "вопроса", "вопросов")}
          {report.skipped.length > 0 && ` · пропущено ${report.skipped.length}: ${report.skipped.join("; ")}`}
        </span>
      )}
      {imp.error && (
        <span className="font-mono text-[11px] text-err" role="alert">
          {imp.error.message}
        </span>
      )}
    </div>
  );
}
